declare namespace $ {

	type $jin_keyboard_row__layout_jin_keyboard_1 = $mol_type_enforce<
		ReturnType< $jin_keyboard['row_layout'] >
		,
		ReturnType< $jin_keyboard_row['layout'] >
	>
	type $jin_keyboard_row__turn_jin_keyboard_2 = $mol_type_enforce<
		ReturnType< $jin_keyboard['row_turn'] >
		,
		ReturnType< $jin_keyboard_row['turn'] >
	>
	type $jin_keyboard_row__input_jin_keyboard_3 = $mol_type_enforce<
		ReturnType< $jin_keyboard['row_input'] >
		,
		ReturnType< $jin_keyboard_row['input'] >
	>
	type $jin_keyboard_row__upcase_jin_keyboard_4 = $mol_type_enforce<
		ReturnType< $jin_keyboard['upcase'] >
		,
		ReturnType< $jin_keyboard_row['upcase'] >
	>
	export class $jin_keyboard extends $mol_view {
		row_layout( id: any): readonly(any)[]
		row_turn( id: any, next?: any ): any
		row_input( id: any, next?: any ): any
		upcase( next?: boolean ): boolean
		area( ): $mol_view
		turn( next?: any ): any
		input( next?: any ): any
		Row( id: any): $jin_keyboard_row
		sub( ): readonly(any)[]
		layout( next?: string ): string
		layouts( ): ({ 
			'': readonly(any)[],
			' ': readonly(any)[],
			'0': readonly(any)[],
			'П': readonly(any)[],
			'И': readonly(any)[],
			'Б': readonly(any)[],
			'.': readonly(any)[],
			'"': readonly(any)[],
			'+': readonly(any)[],
			'@': readonly(any)[],
			'F': readonly(any)[],
			'I': readonly(any)[],
			'N': readonly(any)[],
		}) 
	}
	
	type $jin_keyboard_cell__symbol_jin_keyboard_row_1 = $mol_type_enforce<
		ReturnType< $jin_keyboard_row['cell_title'] >
		,
		ReturnType< $jin_keyboard_cell['symbol'] >
	>
	type $jin_keyboard_cell__turn_jin_keyboard_row_2 = $mol_type_enforce<
		ReturnType< $jin_keyboard_row['cell_turn'] >
		,
		ReturnType< $jin_keyboard_cell['turn'] >
	>
	type $jin_keyboard_cell__input_jin_keyboard_row_3 = $mol_type_enforce<
		ReturnType< $jin_keyboard_row['cell_input'] >
		,
		ReturnType< $jin_keyboard_cell['input'] >
	>
	type $jin_keyboard_cell__upcase_jin_keyboard_row_4 = $mol_type_enforce<
		ReturnType< $jin_keyboard_row['upcase'] >
		,
		ReturnType< $jin_keyboard_cell['upcase'] >
	>
	export class $jin_keyboard_row extends $mol_view {
		cell_title( id: any): string
		cell_turn( id: any, next?: any ): any
		cell_input( id: any, next?: any ): any
		upcase( ): boolean
		turn( next?: any ): any
		input( next?: any ): any
		layout( ): readonly(any)[]
		Cell( id: any): $jin_keyboard_cell
		sub( ): readonly(any)[]
	}
	
	export class $jin_keyboard_cell extends $mol_view {
		start( next?: any ): any
		end( next?: any ): any
		abort( next?: any ): any
		symbol( ): string
		title( ): ReturnType< $jin_keyboard_cell['symbol'] >
		turn( next?: any ): any
		input( next?: any ): any
		upcase( ): boolean
		event( ): ({ 
			pointerdown( next?: ReturnType< $jin_keyboard_cell['start'] > ): ReturnType< $jin_keyboard_cell['start'] >,
			pointerup( next?: ReturnType< $jin_keyboard_cell['end'] > ): ReturnType< $jin_keyboard_cell['end'] >,
			pointercancel( next?: ReturnType< $jin_keyboard_cell['abort'] > ): ReturnType< $jin_keyboard_cell['abort'] >,
		})  & ReturnType< $mol_view['event'] >
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=keyboard.view.tree.d.ts.map